module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.f7b3f5e.ttf";